export const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const toRadians = (deg) => (deg * Math.PI) / 180;
  const R = 6371; // Earth's radius in kilometers

  const dLat = toRadians(lat2 - lat1);
  const dLng = toRadians(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
    Math.cos(toRadians(lat2)) *
    Math.sin(dLng / 2) *
    Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let distance = Math.round(R * c); // Distance in kilometers

  // Fetch preferences from local storage
  const user = localStorage.getItem("userinfo")
    ? JSON.parse(localStorage.getItem("userinfo"))
    : {};
  const preferences = user?.settings || [];
  const preferredDistanceUnit = preferences?.find(
    (item) => item.name === "Preferred Distance"
  )?.value;

  // Convert to miles if preferred unit is "MI"
  if (preferredDistanceUnit === "MI") {
    distance = Math.round(distance * 0.621371); // Convert km to miles
    return `${distance} mi`;
  }

  return `${distance} km`;
};
export const calculateDistanceMeter = (lat1, lng1, lat2, lng2) => {
  const toRadians = (deg) => (deg * Math.PI) / 180;
  const R = 6371; // Earth's radius in kilometers

  const dLat = toRadians(lat2 - lat1);
  const dLng = toRadians(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
    Math.cos(toRadians(lat2)) *
    Math.sin(dLng / 2) *
    Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distanceKm = R * c; // Distance in kilometers

  // Fetch preferences from local storage
  const user = localStorage.getItem("userinfo")
    ? JSON.parse(localStorage.getItem("userinfo"))
    : {};
  const preferences = user?.settings || [];
  const preferredDistanceUnit = preferences?.find(
    (item) => item.name === "Preferred Distance"
  )?.value;

  if (preferredDistanceUnit === "MI") {
    const distanceMi = distanceKm * 0.621371; // Convert km to miles

    return distanceMi < 1
      ? `${Math.round(distanceMi * 5280)} ft` // Convert to feet if < 1 mile
      : `${Math.round(distanceMi)} mi`;
  }

  return distanceKm < 1
    ? `${Math.round(distanceKm * 1000)} m` // Convert to meters if < 1 km
    : `${Math.round(distanceKm)} km`;
};

export const convertBase64 = (resume) => {
  return new Promise((resolve, reject) => {
    if (!(resume instanceof Blob)) {
      reject(new Error("Invalid parameter: Expected a Blob."));
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
    fileReader.readAsDataURL(resume);
  });
};

export function capitalizeFirstLetter(string) {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
}

const origin = window.location.origin;

export const checkTheme = () => {
  if (
    origin == process.env.REACT_APP_ORIGIN_PCN_STAGE ||
    origin == process.env.REACT_APP_ORIGIN_PCN_LIVE ||
    origin == process.env.REACT_APP_ORIGIN_PCN_DEMO ||
    origin == process.env.REACT_APP_ORIGIN_PCN_UAT
  ) {
    return true;
  } else {
    return false;
  }
};

export const checkThemePcw = () => {
  if (
    origin == process.env.REACT_APP_ORIGIN_PCW_STAGE ||
    origin == process.env.REACT_APP_ORIGIN_PCW_LIVE ||
    origin == process.env.REACT_APP_ORIGIN_PCW_DEMO ||
    origin == process.env.REACT_APP_ORIGIN_PCW_UAT
  ) {
    return true;
  } else {
    return false;
  }
};

export const PCW_URL = (() => {
  switch (origin) {
    case process.env.REACT_APP_ORIGIN_PCN_STAGE:
      return process.env.REACT_APP_ORIGIN_PCW_STAGE;
    case process.env.REACT_APP_ORIGIN_PCN_LIVE:
      return process.env.REACT_APP_ORIGIN_PCW_LIVE;
    case process.env.REACT_APP_ORIGIN_PCN_DEMO:
      return process.env.REACT_APP_ORIGIN_PCW_DEMO;
    case process.env.REACT_APP_ORIGIN_PCN_UAT:
      return process.env.REACT_APP_ORIGIN_PCW_UAT;
    default:
      return process.env.REACT_APP_ORIGIN_PCW_STAGE;
  }
})();

export const CHAT_URL = (() => {
  if (
    origin === process.env.REACT_APP_ORIGIN_PCN_LIVE ||
    origin === process.env.REACT_APP_ORIGIN_PCW_LIVE
  ) {
    return process.env.REACT_APP_CHAT_LIVE;
  }

  if (
    origin === process.env.REACT_APP_ORIGIN_PCN_DEMO ||
    origin === process.env.REACT_APP_ORIGIN_PCW_DEMO
  ) {
    return process.env.REACT_APP_CHAT_DEMO;
  }
  if (
    origin === process.env.REACT_APP_ORIGIN_PCN_STAGE ||
    origin === process.env.REACT_APP_ORIGIN_PCW_STAGE
  ) {
    return process.env.REACT_APP_CHAT_STAGE;
  }
  if (
    origin === process.env.REACT_APP_ORIGIN_PCN_UAT ||
    origin === process.env.REACT_APP_ORIGIN_PCW_UAT
  ) {
    return process.env.REACT_APP_CHAT_UAT;
  }

  return process.env.REACT_APP_CHAT_STAGE;
})();

export const STRIP_KEY = (() => {
  if (
    origin === process.env.REACT_APP_ORIGIN_PCN_LIVE ||
    origin === process.env.REACT_APP_ORIGIN_PCW_LIVE
  ) {
    return process.env.REACT_APP_STRIPE_PUBLIC_KEY;
  }

  return process.env.REACT_APP_STRIPE_PUBLIC_KEY_TEST;
})();

export const STRIP_URL = (() => {
  if (
    origin === process.env.REACT_APP_ORIGIN_PCN_LIVE ||
    origin === process.env.REACT_APP_ORIGIN_PCW_LIVE
  ) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  if (
    origin === process.env.REACT_APP_ORIGIN_PCN_DEMO ||
    origin === process.env.REACT_APP_ORIGIN_PCW_DEMO
  ) {
    return process.env.REACT_APP_DEMO_API_PLATINUM;
  }

  if (
    origin === process.env.REACT_APP_ORIGIN_PCN_STAGE ||
    origin === process.env.REACT_APP_ORIGIN_PCW_STAGE
  ) {
    return process.env.REACT_APP_STAGE_URL;
  }

  if (
    origin === process.env.REACT_APP_ORIGIN_PCW_UAT ||
    origin === process.env.REACT_APP_ORIGIN_PCN_UAT
  ) {
    return process.env.REACT_APP_UAT_URL;
  }

  return process.env.REACT_APP_STAGE_URL;
})();

// export const PCW_URL = window.location.origin == 'https://pcn1.aventusinformatics.com' ? 'https://pcw1.aventusinformatics.com' :  window.location.origin == 'https://member.platinumclubnet.com' ? 'https://member.privateclubworld.com' : window.location.origin == 'https://demo-member.platinumclubnet.com' ? 'https://demo-member.privateclubworld.com' :'https://pcw1.aventusinformatics.com'
// export const CHAT_URL = (window.location.origin == 'https://member.platinumclubnet.com' || window.location.origin == 'https://member.privateclubworld.com') ? 'wss://live-chat.platinumclubnet.com' : (window?.location?.origin == 'https://demo-member.platinumclubnet.com' || window?.location?.origin == "https://demo-member.privateclubworld.com") ? 'wss://demo-chat.platinumclubnet.com' : 'wss://mobicom-chat.aventusinformatics.com'
// export const STRIP_KEY = (window.location.origin == 'https://member.platinumclubnet.com' || window.location.origin == 'https://member.privateclubworld.com') ? process.env.REACT_APP_STRIPE_PUBLIC_KEY : process.env.REACT_APP_STRIPE_PUBLIC_KEY_TEST
// export const STRIP_URL = (window.location.origin == 'https://member.platinumclubnet.com' || window.location.origin == 'https://member.privateclubworld.com') ? process.env.REACT_APP_BACKEND_URL : (window?.location?.origin == "https://demo-member.privateclubworld.com" || window?.location?.origin == 'https://demo-member.platinumclubnet.com') ? process.env.REACT_APP_DEMO_API_PLATINUM : (window?.location?.origin == 'https://pcn1.aventusinformatics.com' || window?.location?.origin == 'https://pcw1.aventusinformatics.com') ? process.env.REACT_APP_API_KEY_STRIPE : process.env.REACT_APP_API_KEY_STRIPE

export const replaceSpaceWithUS = (text) => {
  return text.toLowerCase().replace(/\s+/g, "-");
};

export const switchApp = (token, refresh) => {
  let baseUrl = "";

  if (checkTheme()) {
    if (window.location.origin === process.env.REACT_APP_ORIGIN_PCN_LIVE) {
      baseUrl = "https://club.platinumclubnet.com/login";
    } else if (
      window.location.origin === process.env.REACT_APP_ORIGIN_PCN_STAGE
    ) {
      baseUrl = "https://pcn-cms.aventusinformatics.com/login";
    } else if (
      window.location.origin === process.env.REACT_APP_ORIGIN_PCN_DEMO
    ) {
      baseUrl = "https://demo-club.platinumclubnet.com/login";
    } else if (
      window.location.origin === process.env.REACT_APP_ORIGIN_PCN_UAT
    ) {
      baseUrl = "https://uat-club.platinumclubnet.com/";
    }
  } else {
    if (window.location.origin === process.env.REACT_APP_ORIGIN_PCW_LIVE) {
      baseUrl = "https://club.privateclubworld.com/login";
    } else if (
      window.location.origin === process.env.REACT_APP_ORIGIN_PCW_STAGE
    ) {
      baseUrl = "https://pcw-cms.aventusinformatics.com/login";
    } else if (
      window.location.origin === process.env.REACT_APP_ORIGIN_PCW_DEMO
    ) {
      baseUrl = "https://demo-club.privateclubworld.com/login";
    } else if (
      window.location.origin === process.env.REACT_APP_ORIGIN_PCW_UAT
    ) {
      baseUrl = "https://uat-club.privateclubworld.com/login";
    }
  }

  if (baseUrl) {
    window.location.href = `${baseUrl}?token=${token}&refresh=${refresh}`;
  } else {
    console.error("No matching base URL found for this origin.");
  }
};

// export const switchApp = (token, refresh) => {
//     const baseUrl = checkTheme()
//         ? "http://localhost:3000/login"
//         : "http://localhost:3000/login"

//     window.location.href = `${baseUrl}?token=${token}&refresh=${refresh}`;
//   };
